import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useFetchAccountListQuery } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import { changeFilter } from "app/store/dashboard/doctor_analytic/slice/doctorAnalyticSlice";

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { EVOKE_ROLES } from "static/constants";

const AccountFilter = ({ displayAll = true }) => {
  const { data: accounts } = useFetchAccountListQuery();

  const { account } = useSelector((state) => state.doctorAnalytic);
  const userRole = useSelector((state) => state.auth?.currentUser?.role);
  const dispatch = useDispatch();

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="account-select-label">Account</InputLabel>

        <Select
          labelId="account-select-label"
          id="account-select-helper"
          value={account}
          label="Account"
          onChange={(e) => {
            dispatch(
              changeFilter({
                type: "account",
                value: e.target.value,
              })
            );
          }}
          disabled={accounts?.length <= 1 && !EVOKE_ROLES.includes(userRole)}
        >
          {displayAll && accounts?.length > 1 && (
            <MenuItem value="all">All</MenuItem>
          )}
          {accounts?.map(({ name }, index) => (
            <MenuItem key={index} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default AccountFilter;
